export const environment = {
  production: false
};

export var ehsCBAPI = {
  "endpoint": window.location.protocol + "//" + window.location.hostname + "/api",
  "version": "1.0"
}
